import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

const BASE_TELEMETRY_URL = `${environment.apiUrl}/telemetry`;

@Injectable({ providedIn: "root" })
export class TelemetryService {
  constructor(public _http: HttpClient) {}

  getHistoryByReferenceId(referenceId: string): Observable<any> {
    return this._http.get(`${BASE_TELEMETRY_URL}/history/${referenceId}`);
  }
}
